  // Helper: randomly replace words with synonyms
  function replaceWithSynonym(word) {
    const synonyms = {
      very: ['extremely', 'really', 'super', 'quite'],
      good: ['great', 'excellent', 'nice', 'fine'],
      bad: ['awful', 'terrible', 'poor', 'unpleasant'],
      happy: ['joyful', 'cheerful', 'content', 'pleased'],
      sad: ['unhappy', 'down', 'blue', 'depressed'],
      fast: ['quick', 'rapid', 'speedy', 'swift'],
      slow: ['sluggish', 'lethargic', 'unhurried', 'lagging'],
      big: ['large', 'huge', 'enormous', 'massive'],
      small: ['tiny', 'little', 'mini', 'petite'],
      easy: ['simple', 'effortless', 'straightforward', 'uncomplicated'],
      hard: ['difficult', 'tough', 'challenging', 'arduous'],
      like: ['enjoy', 'love', 'appreciate', 'prefer'],
      think: ['believe', 'suppose', 'guess', 'reckon'],
      important: ['crucial', 'vital', 'essential', 'significant'],
      beautiful: ['lovely', 'gorgeous', 'stunning', 'pretty'],
      smart: ['clever', 'bright', 'intelligent', 'sharp'],
      funny: ['amusing', 'hilarious', 'witty', 'entertaining'],
      strong: ['powerful', 'sturdy', 'tough', 'robust'],
      weak: ['fragile', 'frail', 'feeble', 'delicate']
    };
    const lower = word.toLowerCase();
    if (synonyms[lower] && Math.random() < 0.18) {
      let syn = synonyms[lower][Math.floor(Math.random() * synonyms[lower].length)];
      // Preserve capitalization
      if (word[0] === word[0].toUpperCase()) syn = syn.charAt(0).toUpperCase() + syn.slice(1);
      return syn;
    }
    return word;
  }

  // Helper: randomly repeat a word or phrase for emphasis
  function addRedundancy(sentence) {
    // 10% chance to repeat a word for emphasis
    if (Math.random() < 0.1) {
      const words = sentence.split(' ');
      if (words.length > 2) {
        // Pick a random word to repeat (avoid first/last)
        const idx = Math.floor(Math.random() * (words.length - 2)) + 1;
        // Only repeat if not punctuation
        if (/^[a-zA-Z]+$/.test(words[idx])) {
          words[idx] = words[idx] + ', ' + words[idx];
          return words.join(' ');
        }
      }
    }
    return sentence;
  }
// src/Humanizer.js

export function humanizeText(inputText) {
  const paragraphs = inputText.split('\n');
  let humanizedText = '';

  // Helper: randomly introduce a typo in a word
  function introduceTypo(word) {
    if (word.length < 4 || Math.random() > 0.07) return word;
    const typoType = Math.random();
    if (typoType < 0.5 && word.length > 1) {
      // Swap two adjacent letters
      const idx = Math.floor(Math.random() * (word.length - 1));
      return (
        word.slice(0, idx) +
        word[idx + 1] +
        word[idx] +
        word.slice(idx + 2)
      );
    } else {
      // Remove a letter
      const idx = Math.floor(Math.random() * word.length);
      return word.slice(0, idx) + word.slice(idx + 1);
    }
  }

  // Helper: randomly lowercase the first letter of a sentence
  function maybeLowercaseFirst(sentence) {
    if (sentence.length > 0 && Math.random() < 0.15) {
      return sentence[0].toLowerCase() + sentence.slice(1);
    }
    return sentence;
  }

  // Helper: merge or split sentences
  function varySentenceLength(sentences) {
    let result = [];
    let i = 0;
    while (i < sentences.length) {
      if (i < sentences.length - 1 && Math.random() < 0.15) {
        // Merge this and next sentence
        result.push(sentences[i].trim() + ' ' + sentences[i + 1].trim());
        i += 2;
      } else if (sentences[i].length > 20 && Math.random() < 0.1) {
        // Split this sentence at a random space
        const words = sentences[i].split(' ');
        if (words.length > 4) {
          const splitAt = Math.floor(Math.random() * (words.length - 2)) + 1;
          result.push(words.slice(0, splitAt).join(' '));
          result.push(words.slice(splitAt).join(' '));
        } else {
          result.push(sentences[i]);
        }
        i++;
      } else {
        result.push(sentences[i]);
        i++;
      }
    }
    return result;
  }

  for (const paragraph of paragraphs) {
    let humanizedParagraph = paragraph;

    // Randomly remove some commas
    humanizedParagraph = humanizedParagraph.replace(/,/g, (match) => Math.random() < 0.6 ? '' : match);

    // Add or remove spaces around punctuation (.,?!)
    humanizedParagraph = humanizedParagraph.replace(/(\s+)?([,.?!])(\s+)?/g, (match, p1, p2, p3) => {
      const spaceBefore = Math.random() < 0.3 ? ' ' : '';
      const spaceAfter = Math.random() < 0.7 ? ' ' : '';
      return spaceBefore + p2 + spaceAfter;
    });

    // Occasionally swap adjacent words
    humanizedParagraph = humanizedParagraph.replace(/(\b\w+\b)\s+(\b\w+\b)/g, (match, p1, p2) => Math.random() < 0.05 ? p2 + ' ' + p1 : match);

    // Split into sentences (simple split on . ? !)
    let sentences = humanizedParagraph.split(/([.?!])/).reduce((acc, cur, idx, arr) => {
      if (cur.match(/[.?!]/) && acc.length > 0) {
        acc[acc.length - 1] += cur;
      } else if (cur.trim() !== '') {
        acc.push(cur);
      }
      return acc;
    }, []);

    // Vary sentence length by merging or splitting
    sentences = varySentenceLength(sentences);

    // Randomly lowercase first letter, introduce typos, replace with synonyms, and add redundancies
    sentences = sentences.map(sentence => {
      // Lowercase first letter sometimes
      let s = maybeLowercaseFirst(sentence);
      // Introduce typos in words
      s = s.replace(/\b\w+\b/g, (word) => introduceTypo(word));
      // Replace with synonyms
      s = s.replace(/\b\w+\b/g, (word) => replaceWithSynonym(word));
      // Add minor redundancies
      s = addRedundancy(s);
      return s;
    });

    humanizedText += sentences.join(' ') + '\n';
  }

  return humanizedText.trim();
}